import { render, staticRenderFns } from "./SAMC.vue?vue&type=template&id=6afb9a68&scoped=true&"
import script from "./SAMC.vue?vue&type=script&lang=js&"
export * from "./SAMC.vue?vue&type=script&lang=js&"
import style0 from "./SAMC.vue?vue&type=style&index=0&id=6afb9a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb9a68",
  null
  
)

export default component.exports